// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main--BImL1TNz .icons--2w8ZmjjI {\n  width: 50px;\n  margin: 0 auto;\n  cursor: pointer;\n  visibility: hidden;\n}\n\n.main--BImL1TNz:hover .icons--2w8ZmjjI {\n  visibility: visible;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "main--BImL1TNz",
	"icons": "icons--2w8ZmjjI"
};
export default ___CSS_LOADER_EXPORT___;
